







































































































import ComputerEmulator from '../components/ComputerEmulator.vue';
import Vue from 'vue';
import HomeRow from '@/components/HomeRow.vue';
import emulatorVersions from '@/emulatorVersions';
import {version} from '@/version';

export default Vue.extend({
    name: 'home',
    components: { ComputerEmulator, HomeRow },
    data(): {
        latestEmulatorVersion: string,
        ideVersion: string,
    } {
        return {
            latestEmulatorVersion: emulatorVersions[0],
            ideVersion: version,
        };
    },

    mounted() {
        console.log(process.env);
    },
});
